import React, { Component } from "react";
import Toggle from "material-ui/Toggle";
import TripBodyDetailed from "../../../../components/TripBodyDetailed";
import BaggageFeesLink from "../../../../components/BaggageFeesLink";
// import TripSegmentList from "../../../../components/TripSegmentList";
// import TripSegmentHeader from "../../../../components/TripSegmentHeader";
import TripSegmentCompact from "../TripSegmentCompact";
import "./styles.css";
import Card from "../../../../components/Card";
import styled from "styled-components";
import MediaQuery from "../../../../components/MediaQuery";

// Styled components
const TripCard = styled(Card)`
  width: 65%;
  margin: 0 auto;
  margin-bottom: 15px;
  ${MediaQuery.tablet`
    width: 100%;
  `};
`;

// Components
let CardHeader = ({ downPayment, onSelectBtnClick }) => {
  return (
    <div>
      <div class="card-header">
        <div class="card-header__row1">
          <div class="amountDueMsg">
            {" "}
            Due today ={" "}
            <span class="amountDue">
              {" "}
              ${Number(downPayment).toFixed(2)}{" "}
            </span>{" "}
          </div>
          <button
            class="selectBtn btn btn-danger btn-fill"
            type="button"
            onClick={onSelectBtnClick}
          >
            Select <i class="fa fa-chevron-right" />
          </button>
        </div>
      </div>
    </div>
  );
};
let TripBodyCompact = ({ compactTripSegments }) => {
  return <TripSegmentCompact tripSegment={compactTripSegments} />;
};

class Trip extends Component {
  constructor(props) {
    super(props);

    // this.state = { apiDataSource: [], isBackspaceOrDeletePressed: false, from_val: '' };
    this.state = { isCardExpanded: false };
    // this.state = { isCardExpanded: true };
    this.onToggleCard = this.onToggleCard.bind(this);
  }

  onToggleCard(e, isToggled) {
    // console.log('DEBUG', isToggled)
    this.setState({ isCardExpanded: isToggled });
  }

  render() {
    // let { saleTotal, slice, carriers, cabinHash } = this.props.data
    let { data, onSelectBtnClick, tripSegmentHeader } = this.props;
    let {
      baggageFeeUrl,
      downPayment,
      tripSegments,
      compactTripSegments,
      departureDateDisplay
    } = data;

    return (
      <div>
        <TripCard>
          {/* <div class="card"> */}
          <CardHeader
            downPayment={downPayment}
            onSelectBtnClick={onSelectBtnClick}
          />
          <hr />
          <Toggle
            onToggle={this.onToggleCard}
            class="trip-toggle"
            label="View Trip Details"
            labelPosition="right"
            defaultToggled={false}
            labelStyle={{
              fontFamily: "Montserrat",
              textAlign: "left",
              fontSize: "12px"
            }}
          />

          {this.state.isCardExpanded ? (
            <TripBodyDetailed
              departureDateDisplay={departureDateDisplay}
              downPayment={downPayment}
              tripSegments={tripSegments}
              tripSegmentHeader={tripSegmentHeader}
            />
          ) : (
            <TripBodyCompact
              downPayment={downPayment}
              compactTripSegments={compactTripSegments}
            />
          )}
          <BaggageFeesLink baggageFeeUrl={baggageFeeUrl} />
          {/* </div> */}
        </TripCard>
      </div>
    );
  }
}

export default Trip;
// <TripSegmentSeparator />



// WEBPACK FOOTER //
// ./src/scenes/SearchResultsPage/components/Trip/index.js